module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-chunk-header-02.f3e417a1.jpg";